import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { graphQLClient } from "@/graphqlClient";
import {
  CREATE_OR_UPDATE_CONTENT_SUBSCRIPTION,
  GET_CONTENT_SUBSCRIPTIONS_FOR_ENTITY,
} from "@/api/queries";

export interface ContentSubscription {
  id: string;
  path: string;
  parentID: string;
  shardID?: string;
  contractTTL?: number;
  featureIDs?: string[] | null;
}

interface GetContentSubscriptionsForEntityResponse {
  getContentSubscriptionsForEntity: ContentSubscription[];
}

export const useGetClimberContentSubscriptions = (
  climberId: string,
  enabled = true,
) => {
  return useQuery<ContentSubscription[]>({
    queryKey: ["contentSubscriptionsForEntity", climberId],
    queryFn: async () => {
      if (!climberId) return [];
      const res =
        await graphQLClient.request<GetContentSubscriptionsForEntityResponse>(
          GET_CONTENT_SUBSCRIPTIONS_FOR_ENTITY,
          { parentID: climberId },
        );
      return res?.getContentSubscriptionsForEntity ?? [];
    },
    enabled: enabled && !!climberId,
  });
};

interface CreateOrUpdateInput {
  id?: string;
  path?: string;
  parentID: string;
  shardID?: string;
  contractTTL?: number;
  featureIDs: string[];
}

export const useCreateOrUpdateContentSubscription = (climberId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: CreateOrUpdateInput) => {
      return graphQLClient.request(CREATE_OR_UPDATE_CONTENT_SUBSCRIPTION, {
        input,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["contentSubscriptionsForEntity", climberId],
      });
    },
  });
};
